import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Container } from 'semantic-ui-react';
import App from './App';
import GlobalHomeLink from './components/GlobalHomeLink';
import Footer from './components/Footer';
import 'semantic-ui-css/semantic.min.css';
import './index.css';
import './reality-admin.css';
import { UserProvider } from './context/User';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { StatusProvider } from './context/Status';
import './i18n';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <StatusProvider>
      <UserProvider>
        <BrowserRouter>
          <GlobalHomeLink />
          <Container className={'main-content'}>
            <App />
          </Container>
          <Footer />
          <ToastContainer />
        </BrowserRouter>
      </UserProvider>
    </StatusProvider>
  </React.StrictMode>
);
